export const RouteConstants = {
    LOGIN: "/login",
    TEST_DASHBOARD: "/test-dashboard",
    PROFILE: "/profile",
    EDIT_PERSONAL_INFO: "/profile/edit",
    EDIT_SECURITY_INFO: "/profile/security/edit",
    EDIT_PASSWORD_INFO: "/profile/password/edit",
    PURCHASE_HISTORY: "/purchase-history",
    AUTH_CALLBACK: "/callback",
    LOGOUT: "/logout",
    AUTH_ERROR: "/auth-error",
    ADMIN: "/admin",
    ADMIN_SKU_MANAGEMENT: "/admin/manage-sku",
    ADMIN_COUPON_MANAGEMENT: "/admin/manage-coupon",
    FORGOT_PASSWORD: "/forgot-password",
    FORGOT_USERNAME: "/forgot-username",
    FORGOT_USERNAME_SENT: "/forgot-username/sent",
    FORGOT_PASSWORD_SENT: "/forgot-password/sent",
    INCOMPLETE_REGISTRATION: "/incomplete-registration",
    COMPLETE_REGISTRATION_REQUEST_EMAIL_SENT: "/complete-registration-request-email-sent",
    PASSWORD_RESET_AUTH: "/password-reset-auth",
    PASSWORD_RESET: "/password-reset",
    PASSWORD_RESET_ERROR: "/password-reset/error",
    REGISTER: "/register",
    OTC_CALLBACK: "/otcCallback",

    //temporary routes
    PASS_USER_NAME: "/pass-user-name",
    OTC_LOAD: "/otc",

    STUDENT_WELCOME: "/student/welcome",
    STUDENT_ACCOUNT_NOT_SETUP: "/student/unavailable",
    STUDENT_PASSWORD_FORCE_RESET: "/student/password-reset",
    STUDENT_ACCOUNT_LOCKED: "/student/locked"

};